import {Component} from 'substance'

class DWSwitchTextTypeSettings extends Component {
    constructor(...args) {
        super(...args)

        // Defined fields for this extension module
        this.fields = {
            'visible': 'Show text styles in writer'
        }
    }

    render($$) {
        const el = $$('div').append(
            $$('h3').addClass('clear').append(
                this.getLabel('Text styles')
            )
        )

        Object.keys(this.fields).forEach((key) => {
            let value = ''

            /*
             * Incoming key/values from the writer is available in this.props.properties
             */
            if (this.props.properties && typeof this.props.properties[key] !== 'undefined') {
                value = this.props.properties[key]
            }

            // Setting keys are namespaced automatically
            if (key === 'visible') {
                el.append(
                    this.renderInputOption($$, key, this.fields[key], value)
                )
            }
        })

        return el
    }

    renderInputField($$, key, name, value) {
        return $$('div')
            .addClass('form-group flexible-label')
            .append(
                $$('input')
                    .ref(key)
                    .on('change', () => {
                        // Tell the writer that the value for a key have changed
                        this.props.onChange(key, this.refs[key].val())
                    })
                    .addClass('form-control')
                    .attr({
                        required: 'required',
                        type: 'text',
                        id: 'imext-' + key,
                        placeholder: this.getLabel(name)
                    })
                    .val(value),
                $$('label')
                    .attr('for', 'imext-' + key)
                    .append(
                        this.getLabel(name)
                    )
            )
    }

    renderInputOption($$, key, name, value) {
        const UIToggle = this.context.componentRegistry.get('UIToggle')

        return $$('div')
            .addClass('form-group')
            .append(
                $$(UIToggle, {
                    id: 'crop-toggle',
                    label: this.getLabel(name),
                    checked: value ? true : false,
                    onToggle: (checked) => {
                        // Tell the writer that the value for a key have changed
                        this.props.onChange(key, checked)
                    }
                })
            )
    }
}

export {DWSwitchTextTypeSettings}
